import { NewPayment } from '~/lazy/payments/pages/new-payment/models/newPayment';
import * as wizeMobileApi from '@wize-mobile-api';
import { Payment, PaymentStatus, Transfer } from '@qvs/core';
import { NewTransfer } from '~/lazy/payments/pages/new-transfer/models/NewTransfer';

export type Uuid = string;

export enum OrdersPaymentRequestStatusEnum {
  readyToSubmit = 'READY_TO_SUBMIT',
  userSubmit = 'USER_SUBMIT',
  userSubmitSuccess = 'USER_SUBMIT_SUCCESS',
  userSubmitFailure = 'USER_SUBMIT_FAILURE',
  userMaxStatusUpdateFailure = 'USER_MAX_STATUS_UPDATE_FAILURE'
}

export interface OrdersPaymentRequest {
  uuid: Uuid;
  id?: number;
  payment?: NewPayment & Payment;
  transfer?: NewTransfer & Transfer;
  status?:
    | PaymentStatus
    | OrdersPaymentRequestStatusEnum
    | wizeMobileApi.PaymentMobile.OrderStatusEnum
    | wizeMobileApi.PaymentAuthorizationResponse.ApiOrderCreationStatusEnum;
  waitingForAccessAppConfirmation?: boolean;
  paymentCreationResponse?: wizeMobileApi.PaymentMobileCreationResponse | wizeMobileApi.InternalTransferMobileCreationResponse;
  paymentAuthorizationResponse?: wizeMobileApi.ApiOrderInputFormAuthorizationCreationResponse;
  confirmAuthorizedPaymentResponse?: wizeMobileApi.PaymentAuthorizationResponse;
}
